const resorts = {
    resort: [
        {
            name: 'Grenada',
            city: 'St. George\'s',
            country: 'Grenada',
            countryCode: 'GD',
            rstCode: 'SLS',
            link: '/en/sandals-grenada/',
            shortWebDescription: 'The Sandals of tomorrow. An exotic, unspoiled hideaway, Sandals Grenada offers a romantic Caribbean vacation in the heart of Grenada&apos;s exclusive Pink Gin Beach.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-grenada',
            tagLine: 'The sandals of tomorrow'
        },
        {
            name: 'Montego Bay',
            city: 'Montego Bay',
            country: 'Jamaica',
            countryCode: 'JM',
            rstCode: 'SMB',
            link: '/en/montego-bay/',
            shortWebDescription: 'Sandals Montego Bay is Sandals flagship beach resort and a true original. Spanning the most exclusive white-sand beach in Jamaica, this playful and romantic resort is where the world first fell in love with Sandals Resorts.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-montego-bay',
            tagLine: 'Where the party never stops'
        },
        {
            name: 'Ochi',
            city: 'Ocho Rios',
            country: 'Jamaica',
            countryCode: 'JM',
            rstCode: 'SGO',
            link: '/en/ochi/',
            shortWebDescription: '110 acres of lush tropical gardens, creating an exclusive beachfront hideaway complete with 105 pools, 16 unique dining choices, and unlimited golf at nearby Sandals Golf & Country Club.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-ochi',
            tagLine: 'The most happening place'
        },
        {
            name: 'Grande Antigua',
            city: 'St. John\'s',
            country: 'Antigua',
            countryCode: 'AG',
            rstCode: 'SAT',
            link: '/en/grande-antigua/',
            shortWebDescription: 'Voted World&apos;s Leading Honeymoon Resort year after year, this charming seaside oasis is a couple&apos;s paradise set on Antigua&apos;s best and most famous beach, Dickenson Bay.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-grande-antigua',
            tagLine: 'Discover the world\'s most romantic resort'
        },
        {
            name: 'Royal Barbados',
            city: 'St. Lawrence Gap',
            country: 'Barbados',
            countryCode: 'BB',
            rstCode: 'SBR',
            link: '/en/royal-barbados/',
            shortWebDescription: 'Experience the Royal Treatment at Sandals Royal Barbados, the all-new, all-suite beach resort in the spirited St. Lawrence Gap area. The most exclusive all-inclusive ever!',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-royal-barbados',
            tagLine: 'The most exclusive all-inclusive ever'
        },
        {
            name: 'Halcyon Beach',
            city: 'Castries',
            country: 'St. Lucia',
            countryCode: 'LC',
            rstCode: 'SHC',
            link: '/en/halcyon-beach/',
            shortWebDescription: 'A true Garden of Eden by the sea, it’s beachfront island architecture features cottages that are no taller than the highest palm tree, ensuring gorgeous panoramas of Saint Lucia&apos;s tranquil beach and tropical seaside gardens.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-halcyon-beach',
            tagLine: 'A true garden of Eden by a tranquil sea'
        },
        {
            name: 'Grande St. Lucian',
            city: 'Gros-Islet',
            country: 'St. Lucia',
            countryCode: 'LC',
            rstCode: 'SGL',
            link: '/en/grande-st-lucian/',
            shortWebDescription: 'Ideally located on its very own peninsula, Sandals Grande St. Lucian is often described as the "closest vacation to a picture-perfect postcard." Featuring the Spectacular Over-The-Water Bungalows.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-grande-st-lucian',
            tagLine: 'Grand views on its own peninsula'
        },
        {
            name: 'South Coast',
            city: 'Whitehouse',
            country: 'Jamaica',
            countryCode: 'JM',
            rstCode: 'SWH',
            link: '/en/south-coast/',
            shortWebDescription: 'Discover Jamaica&apos;s only all-beachfront, all-oceanview resort set on a 500-acre wilderness preserve. Featuring Over-The-Water Bungalows, Latitudes° Over Water Bar, an Over-The-Water Wedding Chapel, and Jamaica&apos;s largest pool.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-south-coast',
            tagLine: 'Beachfront Oasis'
        },
        {
            name: 'Negril',
            city: 'Negril',
            country: 'Jamaica',
            countryCode: 'JM',
            rstCode: 'SNG',
            link: '/en/negril/',
            shortWebDescription: 'Amidst a pristine tropical setting, this world-class beachfront resort combines a laid-back atmosphere with refined elegance. Spanning the longest and best stretch of Jamaica&apos;s famous seven-mile beach.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-negril',
            tagLine: 'A little bit exotic, a whole lot of chic'
        },
        {
            name: 'Barbados',
            city: 'St. Lawrence Gap',
            country: 'Barbados',
            countryCode: 'BB',
            rstCode: 'SBD',
            link: '/en/sandals-barbados/',
            shortWebDescription: 'Just steps from Barbados&apos; pristine Dover Beach, Sandals Barbados offers undeniable luxury with innovative accommodations such as the all-new Crystal Lagoon Swim-up Suites.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-barbados',
            tagLine: 'Where exclusive is always inclusive'
        },
        {
            name: 'Royal Bahamian',
            city: 'Nassau',
            country: 'Bahamas',
            countryCode: 'BS',
            rstCode: 'SRB',
            link: '/en/royal-bahamian/',
            shortWebDescription: 'A historically regal retreat set on Nassau&apos;s best beach, Sandals Royal Bahamian is for discerning travelers who desire a blend of European sophistication with an exotic offshore island adventure.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-royal-bahamian',
            tagLine: 'A sophisticated European Resort with Offshore Island'
        },
        {
            name: 'Regency La Toc',
            city: 'Castries',
            country: 'St. Lucia',
            countryCode: 'LC',
            rstCode: 'SLU',
            link: '/en/regency-la-toc/',
            shortWebDescription: 'A magnificent 220-acre estate set on a half-mile, crescent-shaped beach. Featuring a challenging executive-style golf course, stunning oceanfront suites and the private enclave of the Sunset Bluff Village.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-la-toc',
            tagLine: 'A glamorous golf resort'
        },
        {
            name: 'Royal Plantation',
            city: 'Ocho Rios',
            country: 'Jamaica',
            countryCode: 'JM',
            rstCode: 'BRP',
            link: '/en/royal-plantation/',
            shortWebDescription: 'Understated elegance and exquisitely private, this is Sandals Royal Plantation - an intimate all-butler beach resort of just 74 ocean view suites tucked into a magnificent coral bluff.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-royal-plantation',
            tagLine: 'Sandals only all-butler boutique resort'
        },
        {
            name: 'Royal Caribbean',
            city: 'Montego Bay',
            country: 'Jamaica',
            countryCode: 'JM',
            rstCode: 'SRC',
            link: '/en/royal-caribbean/',
            shortWebDescription: 'This elegant beach resort features innovative suites including Swim-up Crystal Lagoon Suites and the spectacular Over-the-water Suites. Just offshore, Sandals&pos; own exotic private island offers a romantic retreat.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-royal-caribbean',
            tagLine: 'Jamaica\'s Most Alluring Resort'
        },
        {
            name: 'Royal Curaçao',
            city: 'Santa Barbara',
            country: 'Curaçao',
            countryCode: 'CW',
            rstCode: 'SCR',
            link: '/en/royal-curacao/',
            shortWebDescription: 'Sandals Royal Curaçao is where amazing comes together – with the first-ever Awa Seaside Bungalows, first Kurason Island Suites, Dos Awa 2-Level Infinity Pool, 12 restaurants, and MINI Coopers for complimentary use for select rooms categories.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/general/all-inclusive/home/sandals-royal-curacao',
            tagLine: 'Sandals Newest Destination'
        },
        {
            name: 'Dunn’s River',
            city: 'Ocho Rios',
            country: 'Jamaica',
            countryCode: '',
            rstCode: 'SDR',
            link: '/en/dunns-river/',
            shortWebDescription: 'Nature and luxury go hand-in-hand at Sandals Dunn’s River – the spectacular new resort in the heart of Ocho Rios, Jamaica.',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/resorts/all-resorts-sliders/sdr/sandals-dunns-river.jpg',
            tagLine: 'Sandals Newest Destination'
        },

        {
            name: 'Saint Vincent',
            city: 'Argyle',
            country: 'Saint Vincent and the Grenadines',
            countryCode: '',
            rstCode: 'SSV',
            link: '/en/sandals-saint-vincent/',
            shortWebDescription: 'Leave The World Behind Discover What Lies Off The Beaten Path',
            resortMainImg: '//cdn.sandals.com/sandals/v12/images/resorts/all-resorts-sliders/ssv/sandals_saint_vincent.jpg',
            tagLine: 'Sandals Newest Destination'
        }
    ]
};

module.exports = resorts;
